import React from 'react';

import isNull from 'lodash/isNull';

import { useClassnames } from '@lumapps/classnames';
import { ListSubheader } from '@lumapps/lumx/react';
import { NavigationItemType } from '@lumapps/navigation/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NavigationItemWizardOptionProps, DEFAULT_ENABLED_OPTIONS } from '../../types';
import { ArticleWizardOption } from './ArticleWizardOption';
import { CommunityWizardOption } from './CommunityWizardOption';
import { ContentListWizardOption } from './ContentListWizardOption';
import { ContentWizardOption } from './ContentWizardOption';
import { DirectoryWizardOption } from './DirectoryWizardOption';
import { ExternalLinkWizardOption } from './ExternalLinkWizardOption';
import { JourneyWizardOption } from './JourneyWizardOption';
import { PersonalFeedWizardOption } from './PersonalFeedWizardOption';
import { SectionWizardOption } from './SectionWizardOption';
import { UserDirectoryWizardOption } from './UserDirectoryWizardOption';
import { VideoGalleryWizardOption } from './VideoGalleryWizardOption';

import './index.scss';

const CLASSNAME = 'navigation-item-wizard-options';
export const NavigationItemWizardOptions: React.FC<NavigationItemWizardOptionProps> = ({
    options = DEFAULT_ENABLED_OPTIONS,
    ...rest
}) => {
    const { element } = useClassnames(CLASSNAME);
    const { translateKey } = useTranslate();

    const isSystemPagesPartDisplayed =
        !isNull(options[NavigationItemType.JOURNEYS]) ||
        !isNull(options[NavigationItemType.PERSONAL_FEED]) ||
        !isNull(options[NavigationItemType.VIDEO_GALLERY]);

    return (
        <>
            <ListSubheader className={element('subheader')}>{translateKey(GLOBAL.CREATE)}</ListSubheader>
            {!isNull(options[NavigationItemType.SECTION]) && (
                <SectionWizardOption {...rest} isDisabled={!options[NavigationItemType.SECTION]} />
            )}
            {!isNull(options[NavigationItemType.LINK]) && (
                <ExternalLinkWizardOption {...rest} isDisabled={!options[NavigationItemType.LINK]} />
            )}
            {isSystemPagesPartDisplayed && (
                <>
                    <ListSubheader className={element('subheader')}>{translateKey(GLOBAL.DISPLAY)}</ListSubheader>
                    {!isNull(options[NavigationItemType.JOURNEYS]) && (
                        <JourneyWizardOption {...rest} isDisabled={!options[NavigationItemType.JOURNEYS]} />
                    )}
                    {!isNull(options[NavigationItemType.PERSONAL_FEED]) && (
                        <PersonalFeedWizardOption {...rest} isDisabled={!options[NavigationItemType.PERSONAL_FEED]} />
                    )}
                    {!isNull(options[NavigationItemType.VIDEO_GALLERY]) && (
                        <VideoGalleryWizardOption {...rest} isDisabled={!options[NavigationItemType.VIDEO_GALLERY]} />
                    )}
                </>
            )}
            <ListSubheader className={element('subheader')}>{translateKey(GLOBAL.SELECT)}</ListSubheader>
            {!isNull(options[NavigationItemType.ARTICLE]) && (
                <ArticleWizardOption {...rest} isDisabled={!options[NavigationItemType.ARTICLE]} />
            )}
            {!isNull(options[NavigationItemType.CONTENT]) && (
                <ContentWizardOption {...rest} isDisabled={!options[NavigationItemType.CONTENT]} />
            )}
            {!isNull(options[NavigationItemType.CUSTOM_LIST]) && (
                <ContentListWizardOption {...rest} isDisabled={!options[NavigationItemType.CUSTOM_LIST]} />
            )}
            {!isNull(options[NavigationItemType.COMMUNITY]) && (
                <CommunityWizardOption {...rest} isDisabled={!options[NavigationItemType.COMMUNITY]} />
            )}
            {!isNull(options[NavigationItemType.DIRECTORY]) && (
                <DirectoryWizardOption {...rest} isDisabled={!options[NavigationItemType.DIRECTORY]} />
            )}
            {!isNull(options[NavigationItemType.USER_DIRECTORY]) && (
                <UserDirectoryWizardOption {...rest} isDisabled={!options[NavigationItemType.USER_DIRECTORY]} />
            )}
        </>
    );
};
